import { Alert, Box, Button, Typography } from "@mui/material";
import { useCadastrarEditarProdutoContext } from "../../contexts/CadastrarEditarProdutoContext";
import { FormularioImposto } from "./FormularioImposto";
import {
    ButtonsContainerForm,
    ConfiguracaoContainer,
    Formulario,
    FormularioPaper,
} from "../ConfiguracaoPreparadoContainer/styles";

export const ConfiguracaoImpostoContainer = () => {
    const { imposto, setImposto, handleVoltar } = useCadastrarEditarProdutoContext();

    return (
        <ConfiguracaoContainer>
            <FormularioPaper>
                <Formulario onSubmit={(e) => e.preventDefault()}>
                    <Typography variant="h6" sx={{ width: "100%", marginBottom: "0.5rem" }}>
                        Imposto (fiscal)
                    </Typography>
                    <Alert severity="info" sx={{ marginBottom: "1.5rem" }}>
                        Sugerimos o modelo fiscal base para produção própria. Ajuste o NCM e os demais
                        campos apenas se a sua contabilidade exigir uma classificação diferente.
                    </Alert>

                    <FormularioImposto imposto={imposto} onChange={setImposto} />

                    <ButtonsContainerForm>
                        <Button variant="outlined" onClick={handleVoltar}>Voltar</Button>
                        <Box />
                    </ButtonsContainerForm>
                </Formulario>
            </FormularioPaper>
        </ConfiguracaoContainer>
    );
};
